import * as React from 'react'
import {AttachmentsViewer} from '../../core/components/Controls/Attachments/AttachmentsViewer2'
import {DrawSource} from '../../core/enums/DrawSource'
import {getDateString, parseFeatureFieldsAll} from '../../core/helpers'
import {IPopupDispatcher} from '../../core/interfaces/dispatchers'
import {AttachmentInfos, IFeatureLayerInfo} from '../../core/interfaces/models'
import {Feature} from '../../core/models'
import {getMapService} from '../../core/reducers/map'
import {MapService} from '../../core/services'
import appConfig from '../../reducers/appConfig'
import {PlanHistoryStatus} from './ArchRegister'

class AtchAttachmentsViewer extends AttachmentsViewer {
  process(key: string): boolean {
    return key.indexOf('__MAIN_PDF__') == -1
  }
  attsTitle() {
    return <b>Прикачени файлове</b>
  }

  getName(key: string) {
    return key
  }
  protected getAttachmentsList(stateAttachments: AttachmentInfos): JSX.Element {
    const attachments: Array<JSX.Element> = []
    for (const key in stateAttachments) {
      if (this.process(key)) {
        attachments.push(
          <a
            className="arch-import-att-link"
            key={key}
            target="_blank"
            href={stateAttachments[key].src}
            rel="noreferrer"
          >
            {this.getName(key)}
          </a>
        )
      }
    }
    if (attachments.length == 0) {
      return <div></div>
    }
    return (
      <div
        style={{
          margin: '10px 0'
        }}
      >
        {this.attsTitle()}

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            boxSizing: 'border-box',
            flexDirection: 'column'
          }}
        >
          {attachments}
        </div>
      </div>
    )
  }
}

class AtchPDFAttachmentsViewer extends AtchAttachmentsViewer {
  getName(key: string) {
    return key.replace('__MAIN_PDF__/', '')
  }
  process(key: string): boolean {
    return key.indexOf('__MAIN_PDF__') != -1
  }
  attsTitle() {
    return <b>PDF на проекта</b>
  }
}
interface PopupProps {
  mapService: MapService
  feat: Feature
}
class PopupMap extends React.Component<PopupProps> {
  componentDidMount() {
    this.props.mapService.map.setTarget('popup-ol-map')
    getMapService().drawing.unMark(DrawSource.ExportExtent)
    getMapService().zoomTo([this.props.feat.getGeometry()])
    getMapService().drawing.mark([this.props.feat], DrawSource.ExportExtent)
  }
  componentWillUnmount() {
    this.props.mapService.map.setTarget('ol-map')
  }
  render() {
    return <div id="popup-ol-map" style={{width: '500px', height: '500px'}}></div>
  }
}

interface Props {
  selected: boolean
  onBack: () => void
  historyData?: {
    plan: Feature
    history: Feature[]
  }
  info: IFeatureLayerInfo
  planInfo: IFeatureLayerInfo
  popupDispatcher: IPopupDispatcher
}

interface State {}

export class ArchHisotory extends React.Component<Props> {
  getColor(status: PlanHistoryStatus): string {
    if (status == PlanHistoryStatus.Added) {
      return '#bddcea' //"#0ddb85";
    } else if (status == PlanHistoryStatus.Rejected) {
      return '#ffdfb9' //"#db500d"
    } else if (status == PlanHistoryStatus.Fixed) {
      return '#6e84f3' //"#0dd1db"
    }
    return '#95d894' //"#289205";
  }

  getDotColor(status: PlanHistoryStatus): string {
    if (status == PlanHistoryStatus.Added) {
      return 'rgb(52 124 156)' //"#0ddb85";
    } else if (status == PlanHistoryStatus.Rejected) {
      return 'rgb(179 130 72)' //"#db500d"
    } else if (status == PlanHistoryStatus.Fixed) {
      return 'rgb(60 80 183)' //"#0dd1db"
    }
    return 'rgb(33 154 31)' //"#289205";
  }
  getAttachmentLinks(feat: Feature) {
    const rows: JSX.Element[] = []
    for (const key in feat.attachments) {
      rows.push(<tr></tr>)
    }
    return rows
  }

  getProgress() {
    const nodes: JSX.Element[] = []
    if (this.props.historyData) {
      this.props.historyData.history.forEach((p, i) => {
        const borst =
          this.props.historyData!.history.length == 1
            ? '1px solid #14171a'
            : i == 0
              ? 'none'
              : i == this.props.historyData!.history.length - 1
                ? '1px solid #14171a'
                : 'none'
        const status: PlanHistoryStatus = p.get('ArchPlanHistoryStatusId')
        const isEnd = status == PlanHistoryStatus.Added || status == PlanHistoryStatus.Approved
        const parsedValues = parseFeatureFieldsAll(p, this.props.info)
        nodes.push(
          <tr
            className="arch-history-row"
            key={p.get('Id')}
            style={{
              backgroundColor: this.getColor(status) + '8a',
              borderBottom: borst
            }}
          >
            <td>
              <div className="arch-history-content-left">
                <div>{parsedValues['Created']}</div>
                <div>{parsedValues['ArchPlanHistoryStatusId']}</div>
              </div>
            </td>
            <td>
              <div className="arch-history-row-pipe">
                <div className="arch-history-row-pipe-part" style={{opacity: i == 0 ? 0 : 1}}></div>
                <div
                  className="arch-history-row-pipe-circle"
                  style={{
                    backgroundColor: this.getDotColor(status),
                    borderRadius: isEnd ? '7px' : '5px',
                    minHeight: isEnd ? '14px' : '10px',
                    width: isEnd ? '14px' : '10px'
                  }}
                ></div>
                <div
                  className="arch-history-row-pipe-part"
                  style={{opacity: i == this.props.historyData!.history.length - 1 ? 0 : 1}}
                ></div>
              </div>
            </td>
            <td style={{width: '100%'}}>
              <div>
                <div className="arch-history-content">
                  <div>
                    <b>Коментар от {parsedValues['CreatedUserAlias']}:</b>
                  </div>
                  {p.get('Comment') ? (
                    <p>
                      <div>{p.get('Comment')}</div>
                    </p>
                  ) : (
                    <p>Липсва коментар</p>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      margin: '7px 0',
                      width: '90px'
                    }}
                  >
                    <span>Обхват</span>
                    <span
                      style={{cursor: 'pointer', fontSize: '20px'}}
                      onClick={() => {
                        if (appConfig.isArchImport) {
                          const mapService = getMapService() as MapService
                          this.props.popupDispatcher.addPopups({
                            planExtentMapPopup: {
                              content: <PopupMap feat={p} mapService={mapService}></PopupMap>,
                              header: <div></div>,
                              width: '500px'
                            }
                          })
                        } else {
                          getMapService().drawing.unMark(DrawSource.ExportExtent)
                          getMapService().zoomTo([p.getGeometry()])
                          getMapService().drawing.mark([p], DrawSource.ExportExtent)
                        }
                      }}
                    >
                      <i className="fas fa-map" />
                    </span>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      margin: '7px 0',
                      width: '400px'
                    }}
                  >
                    <span>Заявена дата на създаване на проекта</span>
                    <span>{getDateString(new Date(p.get('PlanCreatedDate')))}</span>
                  </div>
                </div>
              </div>
              <div>
                <AtchPDFAttachmentsViewer
                  attachments={p.attachments}
                  updates={{}}
                  adds={{}}
                  readonly={true}
                  deletes={{}}
                  onAttachmentsChange={() => {}}
                  feature={p}
                  uploadToArchive={false}
                />
                <AtchAttachmentsViewer
                  attachments={p.attachments}
                  updates={{}}
                  adds={{}}
                  readonly={true}
                  deletes={{}}
                  onAttachmentsChange={() => {}}
                  feature={p}
                  uploadToArchive={false}
                />
              </div>
            </td>
          </tr>
        )
      })
    }
    const anonProps = {
      border: 0
    }
    return (
      <table {...anonProps} cellPadding={0} cellSpacing={0} style={{margin: 'auto', padding: '10px', width: '100%'}}>
        <tbody>{nodes}</tbody>
      </table>
    )
  }

  render() {
    if (!this.props.historyData) {
      return null
    }
    const planProps = parseFeatureFieldsAll(this.props.historyData!.plan, this.props.planInfo)
    return (
      <div
        className={'arch-history arch-panel' + (this.props.selected ? '' : ' closed')}
        style={{transform: this.props.selected ? 'translateX(-200%)' : ''}}
      >
        <span className="arch-panel-back" onClick={this.props.onBack}>
          <i className="fas fa-arrow-left" />
        </span>
        <div className="arch-h-title">
          <div>{planProps['ArchPlanTypeId']} проект:</div>
          <div>{planProps['Name']}</div>
        </div>
        <div className="arch-h-title" style={{flexDirection: 'column'}}>
          <div>Създаден от {planProps['CreatedUserAlias']}</div>
          <div>Входящ номер: {planProps['Id']}</div>
          <div>{planProps['Created']}</div>
        </div>
        {this.getProgress()}
      </div>
    )
  }
}
